import { createFileRoute } from "@tanstack/react-router";

import Broadcasts from "@/features/broadcasts/Broadcasts";
import SideNavLayout from "@/layouts/SideNavLayout";
import { BroadcastsMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/broadcasts/")({
  component: () => (
    <SideNavLayout menu={<BroadcastsMenu />}>
      <Broadcasts />
    </SideNavLayout>
  ),
});
